<hub-sub-menu></hub-sub-menu>
<div>
  <button (click)="displayedColumnSet('W')" id="W" class="column_select_button">Work</button>
  <button (click)="displayedColumnSet('C')" id="C" class="column_select_button">Control</button>
  <button (click)="displayedColumnSet('E')" id="E" class="column_select_button">Env</button>
</div>
<ul class="hubhealth">
  <li>
    <button (click)="later()"><span class="created center">Newer</span></button>
    <div *ngIf="environmentVisible" class="environment">
      <span class="temp center">RH</span>
      <span class="separator">|</span>
      <span class="temp center">Raw</span>
      <span class="temp">-</span>
      <div *ngIf="!controlsVisible" class="environment">
        <span class="temp center">°C</span>
        <span class="temp center">Set</span>
      </div>
    </div>
    <div *ngIf="controlsVisible" class="controls">
      <span class="temp center">°C</span>
      <span class="temp center">Set</span>
      <span class="char center">On</span>
      <span class="char center"><img src="/images/flames.svg" width="16" height="24"></span>
      <span class="char center"><img src="/images/pink-holiday-plane.svg" width="18" height="18"></span>
      <span class="char center"><img src="/images/touching-finger.svg" width="16" height="24"></span>
    </div>
    <div *ngIf="workVisible" class="workings">
      <span class="bignum center">version</span>
      <span class="number"><img src="/images/wifi-symbol.svg" width="16" height="16"></span>
      <span class="number center">Gap</span>
      <span class="number center">...</span>
      <span class="bignum center">Up</span>
      <span class="number center">mV</span>
      <div *ngIf="controlsVisible" class="environment">
        <span class="number center">mA</span>
      </div>
    </div>
  </li>
  <div *ngIf="hubhealth; else loading" style="display:block">
    <li *ngFor="let health of hubhealth"
        [style.background-color]="this.getColorFor(health)"
        (click)="this.hubComms(this.health.created)">
      <span class="created">{{health.created | godate}}</span>
      <div *ngIf="environmentVisible" class="environment">
        <span class="temp">{{health.humidity}}</span>
        <span class="separator">|</span>
        <span class="temp">{{health.raw_temp}}</span>
        <span class="number">{{health.bias}}</span>
        <div *ngIf="!controlsVisible" class="environment">
          <span class="temp">{{health.temperature}}</span>
          <span class="temp">{{health.setpoint}}</span>
        </div>
      </div>
      <div *ngIf="controlsVisible" class="controls">
        <span class="temp">{{health.temperature}}</span>
        <span class="temp">{{health.setpoint}}</span>
        <span class="char">{{health.heating}}</span>
        <span class="char" [style.color]="health.boiler ? 'limegreen' : 'orange'">{{health.boiler | boolean}}</span>
        <span class="char" [style.color]="health.holiday ? 'limegreen' : 'orange'">{{health.holiday | boolean}}</span>
        <span class="char" [style.color]="health.touched ? 'limegreen' : 'orange'">{{health.touched | boolean}}</span>
      </div>
      <div *ngIf="workVisible" class="workings">
        <span class="bignum center">{{health.version | version}}</span>
        <span class="number">{{health.rssi}}</span>
        <span class="number">{{health.gap}}</span>
        <span class="number">{{health.avg_wake_secs}}</span>
        <span class="bignum">{{health.uptime | humaninterval}}</span>
        <span class="number">{{health.voltage}}</span>
        <div *ngIf="controlsVisible" class="environment">
          <span class="number">{{health.current}}</span>
        </div>
      </div>
    </li>
  </div>
  <ng-template #loading>Fetching data...</ng-template>
  <li>
    <button (click)="earlier()"><span class="created center">Older</span></button>
    <div *ngIf="environmentVisible" class="environment">
      <span class="temp center">RH</span>
      <span class="separator">|</span>
      <span class="temp center">Raw</span>
      <span class="temp">-</span>
      <div *ngIf="!controlsVisible" class="environment">
        <span class="temp center">°C</span>
        <span class="temp center">Set</span>
      </div>
    </div>
    <div *ngIf="controlsVisible" class="controls">
      <span class="temp center">°C</span>
      <span class="temp center">Set</span>
      <span class="char center">On</span>
      <span class="char center"><img src="/images/flames.svg" width="16" height="24"></span>
      <span class="char center"><img src="/images/pink-holiday-plane.svg" width="18" height="18"></span>
      <span class="char center"><img src="/images/touching-finger.svg" width="16" height="24"></span>
    </div>
    <div *ngIf="workVisible" class="workings">
      <span class="bignum center">version</span>
      <span class="number"><img src="/images/wifi-symbol.svg" width="16" height="16"></span>
      <span class="number center">Gap</span>
      <span class="number center">...</span>
      <span class="bignum center">Up</span>
      <span class="number center">mV</span>
      <div *ngIf="controlsVisible" class="environment">
        <span class="number center">mA</span>
      </div>
    </div>
  </li>
</ul>
